import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PhasrRecommendationsGridController } from '../controller/PhasrRecommendationsGridController';

export class PhasrRecommendationsGridWebComponent extends BaseWebComponentElement {
  public controller!: PhasrRecommendationsGridController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrRecommendationsGridController,
    });
  }

  public async reload(resetSelectionStore = false, forceResetSelectionStore = false) {
    await this.controller.view.dom.$grid.controller?.handleGridItemsLoad(resetSelectionStore, forceResetSelectionStore);
  }

  getCompanyIdFilterValue(): string {
    return this.controller.getCompanyIdFilterValue();
  }
}
